export const removeAstraMetaDiv = () => {
    const astraMetaDiv = document?.querySelector('#astra-meta');

    if (!astraMetaDiv) {
        return;
    }

    astraMetaDiv.remove();
};
